import $ from 'jquery';

// copypasted from here http://www.henryalgus.com/reading-binary-files-using-jquery-ajax/
// use this transport for "binary" data type
$.ajaxTransport('+binary', (options) => {
    const xhr = new XMLHttpRequest();
    return {
        // create new XMLHttpRequest
        send(headers, callback) {
            xhr.addEventListener('load', () => {
                const responseData = {
                    binary: xhr.response,
                };

                callback(
                    xhr.status,
                    xhr.statusText,
                    responseData,
                    xhr.getAllResponseHeaders(),
                );
            });

            const async = true;
            xhr.open(options.type, options.url, async);

            for (const headerName in headers) {
                xhr.setRequestHeader(headerName, headers[headerName]);
            }

            xhr.responseType = options.responseType;

            const requestData = options.data || null;
            xhr.send(requestData);
        },
        abort() {
            xhr.abort();
        },
    };
});
